"use client";
import './../../styles/tailwind-custom.css';
import {
  useMotionValueEvent,
  useScroll,
  useTransform,
  motion,
} from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import './timeline.css'
import { Grid } from './grid-background';

interface TimelineEntry {
  date: string;
  title: string;
  description: string;
  icon?: string;
  features?: { text: string }[];
}


export const Timeline = ({ items }: { items: TimelineEntry[] }) => {
  const ref = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setHeight(rect.height);
    }
  }, [ref]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(scrollYProgress, [0, 1], [0, height]);
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
<div
  className={`tw-w-full tw-bg-transparent tw-font-sans md:tw-px-10 ${
        windowWidth < 400 ? 'tw-pr-0' : 'tw-pr-[25px!important]'
  }`}
  ref={containerRef}
  style={{ padding: windowWidth < 1279 ? '0' : '' }}
>
      <div ref={ref} 
        className="tw-relative tw-max-w-7xl tw-mx-auto tw-pb-20"
        style={{ maxWidth: windowWidth < 1279 ? '100%' : '' }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            className="tw-flex tw-justify-start tw-pt-[8em] md:tw-pt-30 gap-timeline"
            style={{ 
              gap: 
                   windowWidth < 1025 ? '0' : 
                   windowWidth < 1279 ? '8.5rem' : ''
            }}
          >
            <div className="tw-sticky tw-flex tw-flex-col md:tw-flex-row tw-z-40 tw-items-center tw-top-40 tw-self-start tw-max-w-xs lg:tw-max-w-sm md:tw-w-full tw-px-14"
              style={{ 
                paddingRight: windowWidth < 1024 ? '1em' : '' 
              }}
            >
              <div className="tw-h-10 tw-absolute tw-left-3 md:tw-left-3 tw-w-10 tw-rounded-full tw-bg-white dark:tw-bg-black tw-flex tw-items-center tw-justify-center">
                <div className="tw-h-4 tw-w-4 tw-rounded-full tw-bg-neutral-200 dark:tw-bg-neutral-800 tw-border tw-border-neutral-300 dark:tw-border-neutral-700 tw-p-2" />
              </div>
              <h3 
                className="tw-hidden md:tw-block tw-text-xl md:tw-pl-20 md:tw-text-[43px] tw-font-bold tw-text-white/70 tw-min-w-[500px] tw-leading-[50px]"
                style={{ 
                  fontSize: windowWidth < 1279 ? '2.2em' : '',
                  paddingLeft: windowWidth < 1279 ? '1em' : '',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  minWidth: windowWidth < 1279 ? '300px' : '500px',
                  maxWidth: windowWidth < 1279 ? '400px' : '500px',
                  display: windowWidth < 1024 ? 'none' : ''
                }}
              >
                {item.title}
              </h3>
            </div>

            <div className="tw-relative md:tw-mr-[5em] tw-pl-20 tw-pr-4 md:tw-pl-[2rem] max-[618px]:tw-pl-0 tw-w-full"
              style={{ 
                paddingLeft: windowWidth < 1279 ? '0' : '',
                paddingRight: windowWidth < 1279 ? '0' : '',
                marginRight: windowWidth < 1279 ? '0' : ''
              }}
            >
              {windowWidth < 1024 && (
                <h3 
                  className="tw-mb-4 tw-text-left tw-font-bold tw-text-white/70"
                  style={{ 
                    fontSize: windowWidth < 390 ? '25px' :
                             windowWidth < 490 ? '33px' :
                             windowWidth < 767 ? '44px' : 
                             windowWidth < 1279 ? '44px' : '',
                    paddingLeft: windowWidth < 1024 ? '10px' : ''
                  }}
                >
                  {item.title}
                </h3>
              )}
              <div className="slider-cards service-slide-content tw-relative tw-overflow-hidden tw-bg-[#0F172A] tw-rounded-xl tw-p-8 tw-shadow-xl tw-border tw-border-gray-800/50">
                <Grid size={20} />
                <div className="tw-flex tw-items-start tw-gap-4 tw-relative tw-z-10">
                  <div className="tw-flex-1">
                    <h3 
                      className="tw-text-2xl blue-h2-blue-bg tw-font-bold tw-mb-[0]"
                      style={{ 
                        backgroundImage: 'linear-gradient(117deg, rgb(155, 254, 230), rgb(56 178 255))',
                        backgroundClip: 'text',
                        color: 'transparent',
                        WebkitTextFillColor: 'transparent',
                        fontSize: windowWidth < 380 ? '18px' : windowWidth < 500 ? '20px' : '',
                        lineHeight: windowWidth < 499 ? '1.2' : windowWidth < 500 ? '1.3' : ''
                      }}
                    >
                      {item.description}
                    </h3>
                  </div>
                </div>
                {item.features && (
                  <div className="features-section tw-relative tw-z-10">
                    {item.features.map((feature, featureIndex) => (
                      <div 
                        className="icon-text-wrapper tw-flex tw-items-start tw-gap-[0.45rem]" 
                        key={featureIndex}
                        style={{ 
                          display: 'flex',
                          justifyContent: 'flex-start',
                          width: '100%',
                          alignItems: 'flex-start'
                        }}
                      >
                        <svg 
                          className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-blue-500 tw-mt-[5px] hide460px"
                          style={{ color: "rgb(38 240 255)" }}
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                        </svg>
                        <div 
                          className="text-container icon-text-process tw-text-[#ffffffdd] tw-font-semibold"
                          style={{ textAlign: 'left', lineHeight: '24px', paddingTop: '4px',
                            fontSize: windowWidth < 380 ? '15px' : windowWidth < 500 ? '16px' : '',
                           }}
                        >
                          {feature.text}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
        <div
          style={{
            height: height + "px",
          }}
          className="tw-absolute md:tw-left-8 tw-left-8 tw-top-0 tw-overflow-hidden tw-w-[2px] tw-bg-[linear-gradient(to_bottom,var(--tw-gradient-stops))] tw-from-transparent tw-from-[0%] tw-via-neutral-200 dark:tw-via-neutral-700 tw-to-transparent tw-to-[99%]  [mask-image:linear-gradient(to_bottom,transparent_0%,black_10%,black_90%,transparent_100%)]"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="tw-absolute tw-inset-x-0 tw-top-0  tw-w-[2px] tw-bg-gradient-to-t tw-from-purple-500 tw-via-blue-500 tw-to-transparent tw-from-[0%] tw-via-[10%] tw-rounded-full"
          />
        </div>
      </div>
    </div>
  );
};

export const timelineData = [
  {
    date: "2024",
    title: "Expertise Cloud",
    description: "Certifications AWS, Azure et Google Cloud",
    features: [
      { text: "Architecture cloud sécurisée" },
      { text: "Migration sans downtime" },
      { text: "Optimisation des coûts" }
    ]
  },
  {
    date: "2023", 
    title: "Cybersécurité",
    description: "Spécialisation en Threat Intelligence"
  },
  {
    date: "2022",
    title: "Débuts",
    description: "Lancement de l'activité Cloud"
  }
];
